import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import MailingSection from "../sections/MailingSection";

export function CampaignsPage({ mailing }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Рассылки"
        description="Собирайте массовые сообщения, загружайте изображения, настраивайте кнопки и следите за доставкой."
      />
      <PageContent>
        <MailingSection
          mode="page"
          title="Рассылки"
          state={mailing.state}
          actions={mailing.actions}
          selectors={mailing.selectors}
        />
      </PageContent>
    </div>
  );
}

export default CampaignsPage;
